import React, { useState } from 'react';
import { ActionIcon, Center, Group } from '@mantine/core';
import classes from './Header.module.css';
import {
  IconChartBar,
  IconEdit,
  IconGauge,
  IconLayoutGrid,
  IconUsersGroup,
} from '@tabler/icons-react';
import { Link, useNavigate } from 'react-router-dom';
import { RouteUtils } from '@bobex/react-core/routes/RouteUtils';

const links = [
  {
    link: RouteUtils.getBackofficeServletBasename() + '/bo_dashboard',
    label: 'Dashboard',
    icon: IconGauge,
    color: 'green',
  },
  { link: '/sitemap', label: 'Sitemap', icon: IconLayoutGrid, color: 'indigo' },
  {
    link: '/charts-home',
    label: 'Charts',
    icon: IconChartBar,
    color: 'blue',
  },
  {
    link: RouteUtils.getBackofficeServletBasename() + '/bo_partner_rfp_searchform',
    label: 'Search lead',
    icon: IconEdit,
    color: 'yellow',
  },
  {
    link: '/search-user',
    label: 'Search user',
    icon: IconUsersGroup,
    color: 'red',
  },
];

export default function Header() {
  const [active, setActive] = useState(links[0].link);
  const navigate = useNavigate();

  const items = links.map((link, index) => (
    <React.Fragment key={index}>
      <ActionIcon
        color={link.color}
        size="lg"
        key={link.label}
        component={Link}
        to={link.link}
        className={classes.link}
        data-active={active === link.link || undefined}
        variant={active === link.link ? 'outline' : 'filled'}
      >
        <Center>
          {link.icon && <link.icon size={20} />}
          {/*{link.label}*/}
        </Center>
      </ActionIcon>
    </React.Fragment>
  ));

  return (
    <Group justify="space-between" wrap={'nowrap'}>
      {items}
    </Group>
  );
}
